export class OrderPaymentCheckCreationDto {
  constructor(data) {
    this.name = data.name;
    this.number = data.number;
    this.amount = data.amount;
  }
}
